// extracted by mini-css-extract-plugin
export default {"franchiseContainer":"FranchiseType_franchiseContainer__g3jlA","heading":"FranchiseType_heading__rGQu8"};